module.exports = __webpack_public_path__ + "img/server_2.292a854b.jpg";